import {useState} from 'react'
import {useAuthContext} from './useAuthContext'

export const useLogin = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const {dispatch} = useAuthContext()

    const login = async (email, password) => {
        setIsLoading(true)
        setError(null)

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/login`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({email, password}),
            credentials: 'include'
        })
        const json = await response.json()

        if (!response.ok) { //if response is error code, eg 400 then response.ok will be false
            setIsLoading(false)
            setError(json.error)
        }
        if (response.ok) {
            //update the auth context
            dispatch({type: 'LOGIN', payload: json.userData})
            setIsLoading(false)
        }
    }

    return ({login, isLoading, error})
}